import { render, staticRenderFns } from "./Codes.vue?vue&type=template&id=532a8732&scoped=true"
import script from "./Codes.vue?vue&type=script&lang=js"
export * from "./Codes.vue?vue&type=script&lang=js"
import style0 from "./Codes.vue?vue&type=style&index=0&id=532a8732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532a8732",
  null
  
)

export default component.exports